import React from 'react';
import { BadgeDisplay } from './BadgeDisplay';
import { Point } from '@/types';
import { useFocusPoint } from '../hooks/useFocusPoint';
import { useDispatch } from 'react-redux';
import { setContextMenu } from '../points/pointsSlice';
import { isValidNumber } from '../utils/numberUtils';
import { numberFormatter, priceFormatter } from './formatters';

export enum MarketBadgeType {
  BUY = 'buy',
  SELL = 'sell',
  NONE = 'none',
}

export type MarketBadgeProps = {
  assetName: string;
  point: Point;
  style?: React.CSSProperties;
  className?: string;
  showTspName?: boolean;
  type?: MarketBadgeType;
  price?: number;
  volume?: number;
};

export const MarketBadge: React.FC<MarketBadgeProps> = ({
  point,
  assetName,
  style = {},
  className,
  showTspName = false,
  type = MarketBadgeType.NONE,
  price,
  volume,
}) => {
  const dispatch = useDispatch();
  const focusPoint = useFocusPoint();

  const openPointMenu = (evt: React.MouseEvent) => {
    if (!isValidNumber(point?.id)) return;
    evt.preventDefault();
    dispatch(
      setContextMenu({
        pointId: Number(point.id),
        position: { x: evt.clientX, y: evt.clientY },
      }),
    );
  };

  if (!point || !assetName) {
    return null;
  }

  return (
    <BadgeDisplay
      style={style}
      onClick={() => focusPoint(point.id)}
      role="button"
      className={className}
      onContextMenu={openPointMenu}
    >
      {showTspName && (
        <>
          {point.tsp_name}
          <br />
        </>
      )}
      {assetName}
      <p className="mt-2 text-muted">at {point.name}</p>
      {type !== MarketBadgeType.NONE &&
        price !== undefined &&
        volume !== undefined && (
          <p className="m-0 mt-2">
            {type === MarketBadgeType.SELL ? 'Sell' : 'Buy'}{' '}
            {numberFormatter(volume, 0)} dth at {priceFormatter.format(price)}
          </p>
        )}
    </BadgeDisplay>
  );
};
